<template>
    <div id="fd-xwxx">
        <my-title the-title="行为信息"/>
            <van-cell-group class="fd-com-scroll">
                <van-field
                    v-model="formData.nXwbqsxTxt"
                    class="special-readonly"
                    required
                    clearable
                    readonly
                    label="行为保全事项"
                    right-icon="arrow"
                    placeholder="请选择行为保全事项"
                    @click="showXwbqsx = true"
                ></van-field>
                <van-popup v-model="showXwbqsx" position="bottom">
                    <van-picker
                        show-toolbar
                        :columns="codeList_301250"
                        :default-index="0"
                        @cancel="showXwbqsx = false"
                        @confirm="onSxsmConfirm"
                    ></van-picker>
                </van-popup>
                <van-field
                    class="fd-textarea"
                    type="textarea"
                    rows="2"
                    show-word-limit
                    autosize
                    required
                    v-model="formData.cSxsm"
                    label="事项说明"
                    maxlength="200"
                    placeholder="请输入事项说明"
                />

            </van-cell-group>

            <div class="fd-com-btn-container">
                <van-button
                    v-if="formData.xwxxId"
                    type="info"
                    round
                    plain
                    @click="addAndReturn"
                >
                    确定
                </van-button>
                <van-button
                    v-if="!formData.xwxxId"
                    type="info"
                    round
                    plain
                    @click="addAndReturn"
                >
                    添加
                </van-button>
                <van-button
                    v-if="!formData.xwxxId"
                    type="info"
                    round
                    @click="addAndContinue"
                >
                    确认并继续添加
                </van-button>
            </div>
    </div>
</template>

<script>
import MyTitle from '../../../components/common/myTitle';
import {mapGetters} from "vuex";
import validate from "@/utils/validator/validator";
import {addXcxXw,getXcxXw} from '../../../api/guarantee';
import {typeXwbqsx} from "../../../filters/index";
import {csxsmRule, dBqksrq, dBqjsrq} from "@/utils/validator/rules";

export default {
    name: "addXwxx",
    components: {
        MyTitle
    },
    data() {
        return {
            formData:{
                xwxxId: null, // id
                nXwbqsx:'1',
                nXwbqsxTxt:'中止支付信用证项下款项',
                cSxsm:''
            },
            showXwbqsx:false,
        };
    },
    computed: {
        ...mapGetters(['codeList_301250']),
    },
    methods: {
        onSxsmConfirm:function(item){
            this.formData.nXwbqsx=item.keyId;
            this.formData.nXwbqsxTxt=item.text;
            this.showXwbqsx = false;
            console.log('--onSxsmConfirm 111',item);
            console.log('--onSxsmConfirm 222',this.formData);
        },
        //组装提交数据
        params(){
            let {xwxxId,cSxsm,nXwbqsx}=this.formData;
            return {cId:xwxxId,cSxsm,nXwbqsx}
        },
        validateFormData(){
            // 校验规则
            let descriptor={};
            descriptor.cSxsm = csxsmRule;
            return validate(descriptor, this.formData);
        },
        onSubmit(fn){
            console.log('--数据提交 111',this.formData,this.params());
            this.validateFormData().then(() => {
                let currentBqId = JSON.parse(sessionStorage.getItem("currentBqid"));
                console.log('--数据提交222');
                // return false;
                addXcxXw({bqid:currentBqId},this.params()).then((res)=>{
                    console.log('--addXcxXw 123',res);
                    if (res.code ===200) {
                        this.$notify({'type': 'success', 'message': '操作成功'});
                    } else {
                        this.$notify(res.message);
                    }
                    fn();
                }).catch(() => {  console.log(error) });
            });
        },
        addAndReturn(){
            this.onSubmit(()=>{
                this.$router.push("/preservationInfo");
            });
        },
        addAndContinue(){
            this.onSubmit(()=>{
                setTimeout(() => {
                    window.location.reload();
                }, 500);
            });
        },
        initCodeType(){
            this.$store.dispatch('GetCodeType', 301250)
        },
        initData(){
            getXcxXw({id:this.formData.xwxxId}).then(res=>{
                console.log('--initData 123',res);
                var data=res.data;
                this.formData.nXwbqsx=data.nXwbqsx;
                this.formData.nXwbqsxTxt=typeXwbqsx(data.nXwbqsx);
                this.formData.cSxsm=data.cSxsm;
            });
        }
    },
    created() {
        console.log('--created xwxx');
        this.initCodeType()
        var xwxxId = sessionStorage.getItem("bqXwxxId");
        if(xwxxId){
            this.formData.xwxxId = xwxxId;
            this.initData();
        }
    }
}
</script>

<style lang="less" scoped>

#fd-xwxx{
    width: 100%;
    height: 100%;
    overflow: hidden;

        .fd-textarea{
            height: auto;
        }
}
</style>
